import React from 'react';
import { Mail, MessageSquare, Send } from 'lucide-react';

const ContactPage: React.FC = () => {
    return (
        <div className="flex flex-col h-full animate-in fade-in duration-500">
            <div className="mb-6 lg:mb-10 flex items-center justify-between">
                <div>
                    <h1 className="text-2xl lg:text-3xl font-black tracking-tight text-white mb-1">
                        Contacto y Soporte
                    </h1>
                    <p className="text-sm text-[var(--text-muted)] font-medium">
                        ¿Tienes sugerencias o necesitas ayuda? Estamos aquí para escucharte.
                    </p>
                </div>
            </div>

            <div className="max-w-2xl w-full mx-auto flex-1 flex flex-col justify-center pb-20">
                <div className="bg-[var(--bg-card)] border border-[var(--border)] rounded-3xl p-8 lg:p-12 shadow-2xl relative overflow-hidden group">
                    {/* Decorative element */}
                    <div className="absolute -top-32 -right-32 w-64 h-64 bg-indigo-500/10 rounded-full blur-3xl pointer-events-none group-hover:bg-indigo-500/20 transition-all duration-700" />

                    <div className="relative z-10 flex flex-col items-center text-center">
                        <div className="w-20 h-20 mb-6 rounded-2xl bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 flex items-center justify-center shadow-[0_0_30px_rgba(99,102,241,0.15)] group-hover:scale-110 group-hover:shadow-[0_0_40px_rgba(99,102,241,0.25)] transition-all duration-500">
                            <Mail size={40} strokeWidth={1.5} />
                        </div>

                        <h2 className="text-xl lg:text-2xl font-black text-white mb-4">
                            Ponte en contacto con nosotros
                        </h2>

                        <p className="text-[var(--text-muted)] text-sm lg:text-base leading-relaxed mb-8 max-w-md">
                            Para reportar errores, enviar sugerencias de nuevas funcionalidades o cualquier consulta general sobre ChessDrez, escríbenos directamente a nuestro correo electrónico:
                        </p>

                        <a
                            href="mailto:chessdrez26@gmail.com"
                            className="flex items-center gap-3 px-6 py-4 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-white/20 transition-all active:scale-95 group/link"
                        >
                            <Send size={20} className="text-indigo-400 group-hover/link:text-indigo-300 group-hover/link:-translate-y-0.5 group-hover/link:translate-x-0.5 transition-all" />
                            <span className="text-lg font-black text-white tracking-widest font-mono">
                                chessdrez26@gmail.com
                            </span>
                        </a>
                    </div>
                </div>

                {/* Additional Info Cards */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
                    <div className="bg-[var(--bg-card)] border border-[var(--border)] rounded-2xl p-6 flex gap-4 items-start">
                        <div className="p-2.5 rounded-xl bg-orange-500/10 text-orange-400 shrink-0">
                            <MessageSquare size={20} />
                        </div>
                        <div>
                            <h3 className="text-sm font-black text-white uppercase tracking-widest mb-1">Feedback General</h3>
                            <p className="text-xs text-[var(--text-muted)] leading-relaxed">
                                Leemos todos los correos. Tu opinión es fundamental para mejorar la plataforma de ajedrez.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactPage;
